<!-- HEADER -->
<div class="header p-5 position-relative">
  <div class="container position-absolute">

    <div class="text-center mb-3">
      <span class="title-support">{{'Support & FAQ' | translate}}</span>
    </div>

    <div *ngIf="recherche == false" class="d-flex justify-content-center">
      <div class="container">
        <div class="row">
          <div class="col-12 searchbar">
            <div class="container">
              <div class="row">
                <input class="col-11 search_input" type="text" name="search" [(ngModel)]="search" placeholder="{{'Comment pouvons-nous vous aider ?' | translate}}" (keyup.enter)="enterPressSearch()">
                <div *ngIf="search !== ''" class="col-1 p-0">
                  <a class="search_icon" [routerLink]="language.navigateAccordingToLang(['/faq'])" [queryParams]="{search: search}" title="search"><i class="fas fa-search"></i></a>
                </div>
                <div *ngIf="search == ''" class="col-1 p-0">
                  <a class="search_icon" [routerLink]="language.navigateAccordingToLang(['/faq'])" title="search"><i class="fas fa-search"></i></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="recherche == true" class="d-flex justify-content-center">
      <div class="container">
        <div class="row">
          <div class="col-12 mb-4 mb-md-0 col-md-2">
              <a [routerLink]="language.navigateAccordingToLang(['/faq'])" class="back-btn" title="back"><button class="btn btn-immersive btn-rounded"><i class="fas fa-arrow-left mr-2"></i>{{'Retour' | translate}}</button></a>
          </div>
          <div class="col-12 col-md-10">
            <div class="searchbar">
              <div class="container">
                <div class="row">
                  <input class="col-11 search_input" type="text" name="search" [(ngModel)]="search" placeholder="{{'Comment pouvons-nous vous aider ?' | translate}}" (keyup.enter)="enterPressSearch()">
                  <div *ngIf="search !== ''" class="col-1 p-0">
                    <a class="search_icon" [routerLink]="language.navigateAccordingToLang(['/faq'])" [queryParams]="{search: search}" title="search"><i class="fas fa-search"></i></a>
                  </div>
                  <div *ngIf="search == ''" class="col-1 p-0">
                    <a class="search_icon" [routerLink]="language.navigateAccordingToLang(['/faq'])" title="search"><i class="fas fa-search"></i></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    </div>
</div>
<!-- END HEADER -->


<div class="container max-w-perso p-5" *ngIf="recherche == false">
  <div class="row">

    <!-- ASIDE -->
    <div class="col-12 col-lg-3 mx-auto">
      <aside class="w-100" aria-label="Sidebar">
        <div class="aside-menu mb-4">
          <ul class="p-0 m-0 w-100">
            <div *ngFor="let menu of faqSupport; let i = index" class="item-border">
              <li *ngIf="menu.devices && menu.titre[translate.store.currentLang]" class="item d-flex flex-row align-items-center m-auto p-3" [ngClass]="{'blue': i == menuId}" [routerLink]="language.navigateAccordingToLang(['/faq'])" [queryParams]="{tags: menu.id}" fragment="{{menu.devices[0].id}}" title="{{menu.titre[translate.store.currentLang]}}">
                <a class="d-flex flex-row align-items-center w-100 m-auto"><app-svg-icon src="{{menu.icon}}" [size]="'25px'" class="fas mr-3"></app-svg-icon>
                  {{menu.titre[translate.store.currentLang]}}
                </a>
              </li>
              <li *ngIf="!menu.devices && menu.titre[translate.store.currentLang]" class="item d-flex flex-row align-items-center m-auto p-3" [ngClass]="{'blue': i == menuId}" [routerLink]="language.navigateAccordingToLang(['/faq'])" [queryParams]="{tags: menu.id}" title="{{menu.titre[translate.store.currentLang]}}">
                <a class="d-flex flex-row align-items-center w-100 m-auto"><app-svg-icon src="{{menu.icon}}" [size]="'25px'" class="fas mr-3"></app-svg-icon>
                  {{menu.titre[translate.store.currentLang]}}
                </a>
              </li>
            </div>
          </ul>
        </div>
        <div class="contact-us text-center p-5">
          <p>{{'Vous rencontrez encore des problèmes ou difficultés ?' | translate}}</p>
          <a [routerLink]="language.navigateAccordingToLang(['/about-us/o'])" [state]="{'prefillContact' : translate.instant('Aide Support')}" title="contact"><button class="btn btn-immersive btn-rounded"><i class="fas fa-envelope mr-2"></i>{{'Nous contacter' | translate}}</button></a>
        </div>
      </aside>
    </div>
    <!-- END ASIDE -->

    <div class="col-12 col-lg-9" *ngIf="faqSupport[menuId]">

      <!-- DEVICES -->
      <div *ngIf="faqSupport[menuId].devices" class="container min-w-100 mb-4">
        <div class="row">
          <div *ngFor="let device of faqSupport[menuId].devices; let i = index" class="col-6 col-md-3 px-3 pb-3">
            <div class="bloc-device p-0" [ngClass]="{'border-device': i == deviceId}" [routerLink]="language.navigateAccordingToLang(['/faq'])" [queryParams]="{tags: faqSupport[menuId].id}" fragment="{{device.id}}" title="{{device.name}}">
              <div class="gray-devices m-0 text-center" [ngClass]="{'selected': i == deviceId}">
                <picture>
                    <source srcset="{{device.img}}_png.webp" type="image/webp">
                    <source srcset="{{device.img}}.png" type="image/png">
                    <img src="{{device.img}}.png" class="img-device" alt="picture of a {{device.name}}" title="{{device.name}}" loading="lazy"/>
                </picture>
              </div>
              <hr class="mt-0 pt-0">
              <p class="text-center">{{device.name}}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- END DEVICES -->

      <!-- TITLE -->
      <div class="text-center mb-4">
        <span *ngIf="faqSupport[menuId].devices && faqSupport[menuId].devices[deviceId].name" class="title sub-bar">{{faqSupport[menuId].devices[deviceId].name}}</span>
        <span *ngIf="!faqSupport[menuId].devices && faqSupport[menuId].titre[translate.store.currentLang]" class="title sub-bar">{{faqSupport[menuId].titre[translate.store.currentLang]}}</span>
      </div>
      <!-- END TITLE -->

      <!-- DOCUMENTATIONS -->
      <div *ngIf="documentations && documentations.length>0" class="my-5">
        <p class="sub-title mb-4">Documentations</p>
        <div class="download-bloc rounded p-5 downloads d-flex my-4">
          <a *ngFor="let download of documentations" href="{{ download.link }}" target="_blank"><button *ngIf="download.text" class="btn btn-immersive btn-rounded"><i class="fas fa-download mr-2"></i>{{download.text}}</button></a>
        </div>
      </div>
      <!-- END DOCUMENTATIONS -->

      <!-- TUTOS VIDEO -->
      <div class="container min-w-100 m-0 mb-4 p-0" *ngIf="faqSupport[menuId].videos && faqSupport[menuId].videos.length && youtubeVideos">
        <p class="sub-title mb-4">{{'Tutoriels vidéo' | translate}}</p>
        <div class="row" *ngFor="let playlist of youtubeVideos">
          <div class="col-6 col-lg-3 mb-4" *ngFor="let thumbnail of playlist">
            <div class="video rounded border">
              <div class="thumbnail" (click)="video(thumbnail.resourceId.videoId)" data-toggle="modal" data-target="#exampleModalCenter"><img class="image" src='{{thumbnail.thumbnails.medium.url}}' alt="Thumbnail of a video called {{thumbnail.title}}" title="{{thumbnail.title}}" loading="lazy"><img [src]="'assets/youtube-brands-thumbnail.svg'" class="youtube-thumbnail custom-circle" alt="Video play button" title="Play" loading="lazy"></div>
              <p class="youtube-title pt-4 pl-4 pr-4 pb-1">{{thumbnail.title}}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- END TUTOS VIDEO -->

      <!-- FAQ QUESTIONS -->
      <div class="container min-w-100 mb-4 m-0 p-0" *ngIf="filteredFaq.length>0">
        <p class="sub-title mb-4">{{'Foire Aux Questions' | translate}}</p>
        <div class="faq-bloc rounded p-5">
          <!-- <div class="row">
            <div class="col-12">
              <span class="mr-2 font-weight-normal">Tags :</span>
              <span class="faq-tag" (click)="activeTag=null;filterFaq()" [ngClass]="{'active' : activeTag==null}">{{'Tout' | translate}}</span>
              <span class="faq-tag" *ngFor="let tag of faqTags" (click)="activeTag=tag.id;filterFaq()" [ngClass]="{'active' : activeTag==tag.id}">
                {{tag.name[translate.store.currentLang]}}
              </span>
            </div>
          </div>
          <hr class="my-4 py-1"> -->
          <div class="row">
            <div class="col-12">
              <div class="card mb-4" *ngFor="let faq of filteredFaq | orderBy:'position'">
                <div *ngIf="faq.quest[translate.store.currentLang] && faq.rep[translate.store.currentLang]">

                  <div class="card-header m-0 p-0" id="headingFaq{{faq.id}}">
                    <button class="btn btn-block btn-link collapsed" data-toggle="collapse" [attr.data-target]="'#collapseFaq'+faq.id" aria-expanded="false" [attr.aria-controls]="'collapseFaq'+faq.id">
                      {{faq.quest[translate.store.currentLang]}}
                      <div class="indicator"></div>
                    </button>
                  </div>
                  <div id="collapseFaq{{faq.id}}" class="collapse" [attr.aria-labelledby]="'headingFaq'+faq.id">
                    <div class="card-body card-body-faq" [innerHTML]="faq.rep[translate.store.currentLang]">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END FAQ QUESTIONS -->

      <div class="contact-us-bottom text-center p-5">
        <p>{{'Vous rencontrez encore des problèmes ou difficultés ?' | translate}}</p>
        <a [routerLink]="language.navigateAccordingToLang(['/about-us/o'])" [state]="{'prefillContact' : translate.instant('Aide Support')}" title="contact"><button class="btn btn-immersive btn-rounded"><i class="fas fa-envelope mr-2"></i>{{'Nous contacter' | translate}}</button></a>
      </div>

    </div>
  </div>
</div>




<div class="container max-w-perso p-5" *ngIf="recherche == true">
  <div class="row">

    <div class="col-12">

      <!-- TITLE -->
      <div *ngIf="searchText" class="text-center mb-4">
        <span class="title sub-bar">{{'Résultat de la recherche pour :' | translate}} "{{searchText}}"</span>
      </div>
      <!-- END TITLE -->

      <!-- ERROR MESSAGE -->
      <p *ngIf="!filteredDocumentation && !filteredYoutube && !filteredFaq || filteredDocumentation.length==0 && filteredYoutube.length==0 && filteredFaq.length==0 || filteredDocumentation=='null' && filteredYoutube=='null' && filteredFaq=='null'" class="text-center">{{'Aucun résultat ne correspond aux termes recherchés' | translate}}</p>
      <!-- END ERROR MESSAGE -->

      <!-- DOCUMENTATIONS -->
      <div *ngIf="filteredDocumentation && filteredDocumentation.length>0" class="my-5">
        <p class="sub-title mb-4">Documentations</p>
        <div class="download-bloc rounded p-5 downloads d-flex my-4">
          <a *ngFor="let download of filteredDocumentation" href="{{ download.link }}" target="_blank"><button *ngIf="download.text" class="btn btn-immersive btn-rounded"><i class="fas fa-download mr-2"></i>{{download.text}}</button></a>
        </div>
      </div>
      <!-- END DOCUMENTATIONS -->

      <!-- TUTOS VIDEO -->
      <div class="container min-w-100 m-0 mb-4 p-0" *ngIf="filteredYoutube && filteredYoutube.length>0">
        <p class="sub-title mb-4">{{'Tutoriels vidéo' | translate}}</p>
        <div class="row">
          <div class="col-lg-2 col-md-3 col-6 mb-4" *ngFor="let playlist of filteredYoutube">
            <div class="video rounded border">
              <div class="thumbnail" (click)="video(playlist.resourceId.videoId)" data-toggle="modal" data-target="#exampleModalCenter"><img class="image" src='{{playlist.thumbnails.medium.url}}' alt="Thumbnail of a video" title="Thumbnail" loading="lazy"><img [src]="'assets/youtube-brands-thumbnail.svg'" class="youtube-thumbnail custom-circle" alt="Video play button" title="Play" loading="lazy"></div>
              <p class="youtube-title pt-4 pl-4 pr-4 pb-1">{{playlist.title}}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- END TUTOS VIDEO -->

      <!-- FAQ QUESTIONS -->
      <div class="container min-w-100 mb-4 m-0 p-0" *ngIf="filteredFaq.length>0">
        <p class="sub-title mb-4">{{'Foire Aux Questions' | translate}}</p>
        <div class="faq-bloc rounded p-5">
          <div class="row">
            <div class="col-12">
              <span class="mr-2 font-weight-normal">Tags :</span>
              <span class="faq-tag" (click)="activeTag=null;filterTags()" [ngClass]="{'active' : activeTag==null}">{{'Tout' | translate}}</span>
              <span class="faq-tag" *ngFor="let tag of filteredTags" (click)="activeTag=tag.id;filterTags()" [ngClass]="{'active' : activeTag==tag.id}">
                {{tag.name[translate.store.currentLang]}}
              </span>
            </div>
          </div>
          <hr class="my-4 py-1">
          <div class="row">
            <div class="col-12">
              <div class="card mb-4" *ngFor="let faq of filteredFaq | orderBy:'position'">
                <div *ngIf="faq.quest[translate.store.currentLang] && faq.rep[translate.store.currentLang]">

                  <div class="card-header m-0 p-0" id="headingFaq{{faq.id}}">
                    <button class="btn btn-block btn-link collapsed" data-toggle="collapse" [attr.data-target]="'#collapseFaq'+faq.id" aria-expanded="false" [attr.aria-controls]="'collapseFaq'+faq.id">
                      {{faq.quest[translate.store.currentLang]}}
                      <div class="indicator"></div>
                    </button>
                  </div>
                  <div id="collapseFaq{{faq.id}}" class="collapse" [attr.aria-labelledby]="'headingFaq'+faq.id">
                    <div class="card-body card-body-faq" [innerHTML]="faq.rep[translate.store.currentLang]">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END FAQ QUESTIONS -->

    </div>
  </div>
</div>


<!-- Modal -->
<div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <i data-dismiss="modal" class="close fas fa-times-circle"></i>
      <div class="modal-body">
        <div class="embed-responsive embed-responsive-16by9">
          <iframe class="embed-responsive-item" [src]="videoSrc" id="video"  allowscriptaccess="always" allow="autoplay" allowfullscreen></iframe>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- <div class="col-12 col-md-5 mt-3 mt-md-0">
    <img src="{{'assets/faq-fr-anthony-events.jpg' | translate}}" class="block-rounded mb-2" alt="event image">
    <div class="text-center btn-featured-event">
      <a type="button" class="btn btn-download rounded-pill my-4" (click)="$event.stopPropagation()" [href]="language.getAccountink('downloads')">
          <i class="fas fa-download"></i>
          <span class="mx-1"></span>
          <span>{{'Accès à notre campus' | translate}}</span>
      </a>
    </div>
</div> -->

<!-- BEFORE THE PAGE REFONT IN OCTOBER 2022 -->
<!-- <div class="block-featured-event py-5">
<div class="container px-5">
<div class="block px-4 py-5">
<div class="container">
<div class="row">

<div class="col-12 col-md-7">
<b class="event-title">{{'Participez à nos journées portes ouvertes' | translate}}</b>
<p class="description mt-3">{{'Rejoignez-nous tous les jeudis après-midis pour effectuer une visite du campus virtuel aux côtés de notre Custom Success Manager, Anthony Sapin. Au cours de ces interventions, vous pourrez découvrir les nombreux espaces du campus et vous former à son utilisation. Insufflez une nouvelle dynamique à votre parcours de formation HSE avec Immersive Factory !' | translate}}</p>
<div class="container py-2">
<div class="row">
<div class="col-sm col-12 pl-0 ml-0 mr-2">
<p class="infos-featured-event"><app-svg-icon [src]="'assets/svg/date_cercle.svg'" [size]="'30px'" class="fas mr-2 event-icons"></app-svg-icon><span class="bold pr-1">{{'Date :' | translate}}</span>{{'Chaque jeudi' | translate}}</p>
</div>
<div class="col-sm col-12 pl-0 ml-0">
<p class="infos-featured-event"><app-svg-icon [src]="'assets/svg/heure_cercle.svg'" [size]="'30px'" class="fas mr-2 event-icons"></app-svg-icon><span class="bold pr-1">{{'Heure :' | translate}}</span>{{'14h30 - 15h30' | translate}}</p>
</div>
</div>
<div class="row">
<div class="col-sm col-12 pl-0 ml-0 mr-2">
<p class="infos-featured-event"><app-svg-icon [src]="'assets/svg/langage_cercle.svg'" [size]="'30px'" class="fas mr-2 event-icons"></app-svg-icon><span class="bold pr-1">{{'Langues :' | translate}}</span>{{'Français / Anglais' | translate}}</p>
</div>
<div class="col-sm col-12 pl-0 ml-0">
<p class="infos-featured-event"><app-svg-icon [src]="'assets/svg/lieu_cercle.svg'" [size]="'30px'" class="fas mr-2 event-icons"></app-svg-icon><span class="bold pr-1">{{'Lieu :' | translate}}</span>{{'Campus virtuel' | translate}}</p>
</div>
</div>
</div>
<p class="mb-3 speakers">{{'Intervenant :' | translate}}</p>
<app-carousel-people [slides]="slides"></app-carousel-people>
</div>

<div class="col-12 col-md-5 mt-3 mt-md-0">
<img src="{{'assets/faq-fr-anthony-events.jpg' | translate}}" class="block-rounded mb-2" alt="event image">
<div class="text-center btn-featured-event">
<a type="button" class="btn btn-download rounded-pill my-4" *ngIf="!accountService.isLogged()" (click)="$event.stopPropagation();appService.popupAccount()">
<i class="fas fa-download"></i>
<span class="mx-1"></span>
<span>{{'Accès à notre campus' | translate}}</span>
</a>
<a type="button" class="btn btn-download rounded-pill my-4" *ngIf="accountService.isLogged()" (click)="$event.stopPropagation()" [routerLink]="language.navigateAccordingToLang(['/downloads'])">
<i class="fas fa-download"></i>
<span class="mx-1"></span>
<span>{{'Accès à notre campus' | translate}}</span>
</a>
</div>
</div>

</div>
</div>
</div>
</div>
</div>




<div class="container py-5" *ngIf="youtubeVideos">
<div class="text-center mb-4">
<span class="title sub-bar">{{'Découvrez nos tutos vidéo' | translate}}</span>
</div>
<div class="videos autres">
<div class="row ml-0 mr-0">
<div class="col-md-4 mt-4" *ngFor="let thumbnail of youtubeVideos">

<div class="video rounded border">
<div class="thumbnail" (click)="video(thumbnail.resourceId.videoId)" data-toggle="modal" data-target="#exampleModalCenter"><img class="image" src='{{thumbnail.thumbnails.medium.url}}'><img [src]="'assets/youtube-brands-thumbnail.svg'" class="youtube-thumbnail custom-circle"></div>
<p class="youtube-title pt-4 pl-4 pr-4 pb-1">{{thumbnail.title}}</p>
</div>

</div>
</div>

</div>
</div>





<div class="block-help py-5">
<div class="text-center mb-4">
<span class="title sub-bar">{{'Aide en ligne' | translate}}</span>
</div>
<div class="container px-5">
<div class="block p-5 text-center contact">
<p><span class="font-weight-bold">{{'Pour tous problèmes ou difficultés, veuillez contacter notre Custom Success Manager via notre Live Tchat ou par email.' | translate}}</span><br/>{{'Notre support client est disponible de 9h à 18h du lundi au vendredi (fuseau horaire français) :' | translate}}</p>
<p class="pb-2"><a class="link word-break" href="mailto: support@immersivefactory.com">support@immersivefactory.com</a></p>
<hr class="pb-2">
<p class="font-weight-bold">{{'Pour toutes demandes de démos en visio-conférence ou pour contacter nos Key Account Managers :' | translate}}</p>
<div class="text-center btn-featured-event mt-2">
<a type="button" class="btn btn-contact rounded-pill" [routerLink]="language.navigateAccordingToLang(['/about-us/o'])"><i class="fas fa-envelope pr-2"></i>{{'Nous contacter' | translate}}</a>
</div>
</div>
</div>
</div>


<div class="container faq-tags mt-5">
<div class="text-center my-5 mb-5">
<span class="title sub-bar">FAQ</span>
</div>
<div class="row">
<div class="col-12 col-lg-10 offset-lg-1 searchBar">
<input type="text" name="search" [(ngModel)]="search" (keyup)="filterFaq()" class="form-control" placeholder="{{'Rechercher' | translate}}">
</div>
</div>
</div>


<div class="container faq-tags mt-4">
<div class="row">
<div class="col-12 col-lg-10 offset-lg-1">
<span class="faq-tag" (click)="activeTag=null;filterFaq()" [ngClass]="{'active' : activeTag==null}">{{'Tout' | translate}}</span>
<span class="faq-tag" *ngFor="let tag of faqTags" (click)="activeTag=tag.id;filterFaq()" [ngClass]="{'active' : activeTag==tag.id}">
{{tag.name[translate.store.currentLang]}}
</span>
<hr class="my-5">
</div>
</div>
</div>

<div class="container faq-content mb-5">

<div class="row">
<div class="col-12 col-lg-10 offset-lg-1">

<p class="text-center text-muted mt-4" style="font-size:18px;font-weight:500" *ngIf="filteredFaq.length == 0">{{'Aucun résultats trouvés pour les paramètres choisis' | translate}}</p>

<div class="card mb-4" *ngFor="let faq of filteredFaq | orderBy:'position'"><div *ngIf="faq.quest[translate.store.currentLang] && faq.rep[translate.store.currentLang]">
<div class="card-header m-0 p-0" id="headingFaq{{faq.id}}">
<button class="btn btn-block btn-link collapsed" data-toggle="collapse" [attr.data-target]="'#collapseFaq'+faq.id" aria-expanded="false" [attr.aria-controls]="'collapseFaq'+faq.id">
{{faq.quest[translate.store.currentLang]}}
<div class="indicator"></div>
</button>
</div>

<div id="collapseFaq{{faq.id}}" class="collapse" [attr.aria-labelledby]="'headingFaq'+faq.id">
<div class="card-body card-body-faq" [innerHTML]="faq.rep[translate.store.currentLang]">
</div>
</div>
</div></div>

</div>

</div>



</div> -->


<!-- <app-they-trust-us></app-they-trust-us> -->
